import { UserPlus, Mail, Star, UserCheck } from "lucide-react";

export const FUNNEL_STAGES = [
  { key: "NEW", label: "Awareness", sublabel: "New leads discovered", icon: UserPlus, color: "from-blue-500 to-blue-600", textColor: "text-blue-400", bgColor: "bg-blue-500/10", borderColor: "border-blue-500/20" },
  { key: "CONTACTED", label: "Engaged", sublabel: "First contact made", icon: Mail, color: "from-cyan-500 to-cyan-600", textColor: "text-cyan-400", bgColor: "bg-cyan-500/10", borderColor: "border-cyan-500/20" },
  { key: "QUALIFIED", label: "Qualified", sublabel: "Ready to convert", icon: Star, color: "from-amber-500 to-amber-600", textColor: "text-amber-400", bgColor: "bg-amber-500/10", borderColor: "border-amber-500/20" },
  { key: "CONVERTED", label: "Converted", sublabel: "Closed deals", icon: UserCheck, color: "from-emerald-500 to-emerald-600", textColor: "text-emerald-400", bgColor: "bg-emerald-500/10", borderColor: "border-emerald-500/20" },
];

export const STATUS_OPTIONS = ["NEW", "CONTACTED", "QUALIFIED", "CONVERTED"] as const;

export const STATUS_STYLES: Record<string, string> = {
  NEW: "bg-blue-500/10 text-blue-400",
  CONTACTED: "bg-yellow-500/10 text-yellow-400",
  QUALIFIED: "bg-purple-500/10 text-purple-400",
  CONVERTED: "bg-green-500/10 text-green-400",
  LOST: "bg-gray-500/10 text-gray-400",
  OPTED_OUT: "bg-red-500/10 text-red-400",
};

export const STATUS_COLORS: Record<string, { bg: string; text: string; border: string }> = {
  NEW: { bg: "bg-blue-500/10", text: "text-blue-400", border: "border-blue-500/30" },
  CONTACTED: { bg: "bg-yellow-500/10", text: "text-yellow-400", border: "border-yellow-500/30" },
  QUALIFIED: { bg: "bg-purple-500/10", text: "text-purple-400", border: "border-purple-500/30" },
  CONVERTED: { bg: "bg-green-500/10", text: "text-green-400", border: "border-green-500/30" },
};

export const CADENCE_OPTIONS = [1, 3, 5, 7, 14, 30];

export const APPOINTMENT_STATUS_STYLES: Record<string, { bg: string; text: string; border: string }> = {
  SCHEDULED: { bg: "bg-blue-500/10", text: "text-blue-400", border: "border-blue-500/30" },
  CONFIRMED: { bg: "bg-green-500/10", text: "text-green-400", border: "border-green-500/30" },
  COMPLETED: { bg: "bg-emerald-500/10", text: "text-emerald-400", border: "border-emerald-500/30" },
  CANCELLED: { bg: "bg-red-500/10", text: "text-red-400", border: "border-red-500/30" },
  NO_SHOW: { bg: "bg-amber-500/10", text: "text-amber-400", border: "border-amber-500/30" },
};
